const getAppMenus = (portalKey, isMBAdmin, roleAccess, isAdmin, isMCUserExpired, isMCUserPartiallyApproved, isMCUserPartiallyVerified) => {     
    const appMenuItems = [];

    const addMenuItem = (name, link, orderID, key) => {
        appMenuItems.push({ name, link, orderID, key });
    };

    switch (portalKey.toLowerCase()) {
        case "ai":
            // addMenuItem('Account Search', 'dashboardAI', 1);
            // addMenuItem('Upload', 'upload', 2);
            return appMenuItems;
        case "ea":
            const {
              hasViewManageSeasonsAccess,
              hasAccountBalanceReportAccess,
              hasEnergyUsageReportAccess,
              hasOutstandingGrantReportAccess,
              hasReconnectionRequestReportAccess,
            } = roleAccess;

            addMenuItem('Account Lookup', 'dashboardEA', 1, 'dashboard');
            isAdmin &&
              hasViewManageSeasonsAccess &&
              addMenuItem(
                "Manage Seasons",
                "ea-manage-seasons",
                2,
                "ea-manage-seasons"
              );
            appMenuItems.push({
              name: "Reports",
              orderID: 3,
              items: [
                hasAccountBalanceReportAccess && {
                  name: "Account Balance",
                  link: "ea-reports-account-balance",
                  orderID: 1,
                },
                hasEnergyUsageReportAccess && {
                  name: "Energy Usage & Billing Cost",
                  link: "ea-reports-energy-usage",
                  orderID: 2,
                },
                hasOutstandingGrantReportAccess && {
                  name: "Outstanding Grants",
                  link: "ea-reports-outstanding-grant",
                  orderID: 3,
                },
                hasReconnectionRequestReportAccess && {
                  name: "Reconnection Request",
                  link: "ea-reports-reconnection-request",
                  orderID: 4,
                },
                hasReconnectionRequestReportAccess && {
                  name: "Pledge Amount Request",
                  link: "ea-reports-pledge-amount",
                  orderID: 5,
                },
                hasReconnectionRequestReportAccess && {
                  name: "Emergency Hold Request",
                  link: "ea-reports-emergency-hold-request",
                  orderID: 6,
                },
              ].filter(Boolean),
            });
            return appMenuItems;
        case "mc":
            if (!isMCUserExpired && !isMCUserPartiallyApproved && !isMCUserPartiallyVerified) {
                addMenuItem('Request List', 'dashboardMC', 1, 'dashboard');
            }            
            if (isAdmin) {
                appMenuItems.push({
                    name: "Reports",
                    orderID: 3,
                    items: [
                        { name: "Map Request", link: "map-request-report", orderID: 1 },
                        {
                            name: "Security Review",
                            link: "security-review-report",
                            orderID: 2,
                        },
                    ],
                });
            }
            return appMenuItems;
        case "mb":
            if(roleAccess.hasViewPipelineNominationAccess || roleAccess.hasViewPipelineDeliveryMatrixAccess || roleAccess.hasViewGroupNominationAccess || roleAccess.hasViewPipelineDeliveryGuideAccess)
            appMenuItems.push({
                name: 'Nominations',
                orderID: 1,
                items: [
                  (roleAccess.hasViewPipelineNominationAccess || roleAccess.hasViewGroupNominationAccess) && { name: 'Nominations', link: "nomination", order: 1 },
                    // { name: 'NOMINATIONS BY PIPELINE', link: 'nominationPipeline', orderID: 4 },
                    // { name: 'NOMINATIONS BY GROUP', link: 'nominationGroup', orderID: 2},
                  (roleAccess.hasViewPipelineDeliveryMatrixAccess || roleAccess.hasViewPipelineDeliveryGuideAccess) &&   { name: 'Pipeline Delivery', link: 'pipelinedelivery', orderID: 3 },
                  (roleAccess.hasGetDRVForecastAccess) &&   { name: 'System DRV & OFO', link: 'forecast-drv', orderID: 3 },
                  (roleAccess.hasManageStorageTrackingAccess) && { name: 'Storage Tracking', link: 'storage-tracking', orderID: 4 },
                  { name: 'Matrix Compliance', link: 'matrix-compliance', orderID: 5 },

                ].filter(Boolean)
            });
            addMenuItem('File hub', 'Filehub', 2);
            if(roleAccess.hasViewAlphaBetaAndEOMServiceStatusAccess)
                addMenuItem('Services', 'services', 3);
            if(roleAccess.hasViewSummaryAdjustmentsByInterruptibleMarketerGroupsAccess)
                appMenuItems.push({
                    name: 'Adjustments',
                    orderID: 4,
                    items: [
                        { name: 'By Firm', link: 'byfirm', orderID: 1 },
                        { name: 'By Interruptible', link: 'byInterruptible', orderID: 2 }
                    ]
                });
            if(roleAccess.hasViewCustomerAccountDetailsAccess)
                addMenuItem('Customers', 'customerDetails', 5);
            const reportItems = [
                    roleAccess.hasAdjustmentActivityInterruptibleReportAccess && { name: 'Adjustment Activity Interruptible', link: 'activityinterruptible', order: 1 },
                    (isAdmin && roleAccess.hasDC_NominationReallocationReportAccess) && { name: 'DC Nomination Reallocations', link: 'dcreports', order: 2 },
                    roleAccess.hasCustomerUsageReportAccess && { name: 'Customer Usage', link: 'csreports', order: 3 },
                    roleAccess.has5DaysRequirementForecastReportAccess && { name: '5 Days Requirement Forecast', link: 'foreCastReports', order: 4 },
                    roleAccess.hasMonthlyStorageReportAccess && { name: 'Monthly Storage', link: 'monthlyreports', order: 5 },
                    roleAccess.hasNominationComplianceReportAccess && { name: 'Nomination Compliance', link: 'nominationcompliance', order: 6 },
                    roleAccess.hasPipelineConfirmationReportAccess && { name: 'Pipeline Confirmation', link: 'pipelineconfirmation', order: 7 },
                    roleAccess.hasSummaryNominationComplianceReportAccess && { name: 'Summary Nomination Compliance', link: 'SummaryNominationComplianceReport', order: 8 },
                    roleAccess.hasSummaryStorageByMarketerReportAccess && { name: 'Summary Storage by Marketer', link: 'summaryStorage', order: 9 },
                    roleAccess.hasSupplierActiveCustomersReportAccess && { name: 'Supplier Active Customers', link: 'SupplierActiveCustomer', order: 10 },
                    roleAccess.hasSupplierPendingEnrollmentOrDropReportAccess && { name: 'Supplier Pending Enrollment/Drops', link: 'supplierPendingEnrollmentOrDrop', order: 11 },
                    roleAccess.hasSummarySupplyByCityGateReportAccess && { name: 'Summary Supply by City Gate', link: 'citygatereports', order: 12 },
                    roleAccess.hasDoNotTransferReportAccess && { name: 'Do Not Transfer', link: 'dntreports', order: 13 },
                    roleAccess.hasBaseAndHeatFactorReportAccess && { name: 'Base and Heat Factors', link: 'base-and-heat-factor-report', order: 14 }
                ].filter(Boolean).sort((a, b) => a.name.localeCompare(b.name));
                if (reportItems.length > 0) {
                    appMenuItems.push({
                        name: 'Reports',
                        orderID: 5,
                        items: reportItems
                    });
                }
            
            return appMenuItems;
        case "sd":
            addMenuItem('Supplier', 'dashboardSD', 1);
            return appMenuItems;
        case "admin":
            appMenuItems.push({
                name: 'Users',
                orderID: 1,
                items: []
            });                   
            if (isAdmin) {
              appMenuItems.push({
                name: "Manage Organizations",
                orderID: 2,
                items: [
                  isMBAdmin &&
                    roleAccess.hasViewMarketerAccess && {
                      name: "Marketers",
                      link: "marketer",
                      orderID: 6,
                    },
                  isMBAdmin &&
                    roleAccess.hasViewMarketerAccess && {
                      name: "Marketer Group",
                      link: "marketerGroup",
                      orderID: 7,
                    },
                  roleAccess.hasViewEAAgencyAccess &&
                    roleAccess.hasAddEAAgencyAccess &&
                    roleAccess.hasUpdateEAAgencyAccess &&
                    roleAccess.hasDeleteEAAgencyAccess && {
                      name: "EA Agency",
                      link: "manage-ea-agency",
                      orderID: 3,
                    },
                  roleAccess.hasViewAIAgencyAccess &&
                    roleAccess.hasAddAIAgencyAccess &&
                    roleAccess.hasUpdateAIAgencyAccess &&
                    roleAccess.hasDeleteAIAgencyAccess && {
                      name: "AI Agency",
                      link: "manage-ai-agency",
                      orderID: 4,
                    },
                  roleAccess.hasViewMCAgencyAccess &&
                    roleAccess.hasAddMCAgencyAccess &&
                    roleAccess.hasUpdateMCAgencyAccess &&
                    roleAccess.hasDeleteMCAgencyAccess && {
                      name: "Map Requestor",
                      link: "manage-map-requestor",
                      orderID: 5,
                    },
                  {
                    name: "Marketer Pipelines",
                    link: "manage-marketer-pipeline",
                    orderID: 8,
                  },
                ]
                  .filter(Boolean)
                  .sort((a, b) => a.name.localeCompare(b.name)),
              });
            }
            
            if(roleAccess.hasViewAccountMarketerAssociationAccess) {
                addMenuItem('Customers', 'customer', 3);
            }
            if (roleAccess.hasViewAnnouncementsAndNotificationsAccess) {
                addMenuItem('Announcements', 'announcement', 4);
            }
            if(roleAccess.hasUpdateSupportContactInformationAccess) {
                appMenuItems.push({
                    name: 'Support',
                    orderID: 5,
                    items: [
                        roleAccess.hasUpdateSupportContactInformationAccess && { name: 'Support', link: 'support', orderID: 1 },
                    ].filter(Boolean)
                });
            }
            appMenuItems.sort((a, b) => a.orderID - b.orderID);
            return appMenuItems;
        case "reviewer":
            // addMenuItem('Users', 'userprofile', 1);
            appMenuItems.push({
                name: 'Users',
                orderID: 1,
                items: []
            });
            return appMenuItems;
        default:
            return appMenuItems;
    }

    // Sort the menu items by orderID
    // appMenuItems.sort((a, b) => a.orderID - b.orderID);

    // return appMenuItems;
};

export default getAppMenus;